module.exports = __webpack_public_path__ + "static/media/Kirsakova.8c2cfcd5.png";